import creditCardType from 'credit-card-type';

const isProperLength = (value) => {
  const regex = new RegExp("^[0-9]{13,19}$");
  return regex.test(getCleanCardNumber(value));
};

const isNumberLuhnValid = (function (arr) {
  return function (value) {
    const number = getCleanCardNumber(value);
    let len = number.length;
    let bit = 1;
    let sum = 0;
    let val;

    while (len) {
      val = parseInt(number.charAt(--len), 10);
      /* eslint-disable-next-line no-cond-assign */
      sum += (bit ^= 1) ? arr[val] : val;
    }

    return sum && sum % 10 === 0;
  };
}([0, 2, 4, 6, 8, 1, 3, 5, 7, 9]));

const getCardType = function (value) {
  return creditCardType(getCleanCardNumber(value));
};

var getCleanCardNumber = function (value) {
  if (!value) return '';

  return (value || '').replace(/[^\d]/g, '');
};

export default {
  isNumberLuhnValid: isNumberLuhnValid,
  getCardType: getCardType,
  getCleanCardNumber: getCleanCardNumber,
  isProperLength,
};
